import classNames from 'classnames';
import { ChangeEvent, FC, useActionState, useEffect, useState } from 'react';

import { forgotPasswordAction } from '@/features/auth';
import { Input } from '@/shared/ui';
import { useModalStore } from '@/widgets/modals/model/store';

import styles from './forgotPassword.module.scss';

interface ResetPasswordProps {
  className?: string;
}

const initialState = {
  message: '',
  success: false,
  fieldErrors: { email: '' },
};

const ForgotPassword: FC<ResetPasswordProps> = (props) => {
  const { className } = props;
  const { closeModal } = useModalStore();
  const [state, formAction, isPending] = useActionState(
    forgotPasswordAction,
    initialState,
  );

  const [form, setForm] = useState({
    email: '',
  });

  useEffect(() => {
    if (state.success) {
      closeModal();
    }
  }, [state, closeModal]);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.container__content}>
        <div className={styles.container__titleBlock}>
          <p className={styles.container__title}>Сбросить пароль</p>
        </div>
        <div className={styles.container__textBlock}>
          <p className={styles.container__text}>
            Укажите вашу почту и мы отправим вам ссылку для сброса пароля
          </p>
        </div>
        <form action={formAction} className={styles.container__form}>
          <Input
            className={styles.container__form_input}
            error={state?.fieldErrors?.email}
            label="E-mail"
            name="email"
            value={form.email}
            onChange={handleInputChange}
          />
          <button
            className={classNames('button button--confirm-white')}
            disabled={isPending}
          >
            Отправить
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
